/*
 * @Description: Description
 * @Author: zhaoqianqian
 * @Date: 2021-10-29 13:58:43
 * @LastEditors: liyunfei 3090384495@qq.com
 * @LastEditTime: 2026-04-01 18:42:12
 */
import elLocale from 'element-ui/lib/locale/lang/el.js'
import agrEn from './agr-en'
export default {
    // ai报告相关
    ai: {
        report: "Ανάλυση Αναφοράς AI",
        train: "Εκπαιδευτική Δομή",
        loading: "Φόρτωση, παρακαλώ περιμένετε...",
        loadingError1: "Η αναφορά δεν φορτώθηκε",
        loadingError2: "Συγγνώμη. Δοκιμάστε ξανά αργότερα.",
    },
    // 登录页面
    login: {
        loginAndRegister: 'Εγγραφή / Σύνδεση',
        registerAndLogin: 'Σύνδεση/Εγγραφή',
        userLogin: 'Σύνδεση',
        title: 'Οι λογαριασμοί κινητού και email είναι ξεχωριστοί. Σημειώστε τον τύπο σας.',
        mobileLogin: 'Τηλέφωνο',
        emailLogin: 'Email',
        email: 'E-mail',
        loginBtn: 'Σύνδεση',
        autoLogin: 'Να με θυμάσαι',
        retransmission: '{item}s',
        formList: [
            {
                label: 'Αριθμός τηλεφώνου',
                placeholder: 'Συνέχεια',
            },
            {
                label: 'Κωδικός',
                placeholder: 'Κωδικός επαλήθευσης',
            },
            {
                label: 'Εισαγωγή email',
            },
        ],
        btn: {
            submit: 'Δημιουργία λογαριασμού',
            title: 'Για να έχετε ακριβή δεδομένα, είναι σημαντικό να εισάγετε σωστά το ύψος, το φύλο και την ηλικία σας.',
        },
        rule: {
            phone: {
                requiredMsg: 'Μη έγκυρη μορφή αριθμού τηλεφώνου',
                patternMsg: 'Ο αριθμός τηλεφώνου δεν είναι εγγεγραμμένος, δημιουργήστε τον λογαριασμό σας',
            },
            authCode: {
                requiredMsg: 'Σφάλμα κωδικού επαλήθευσης. Παρακαλώ εισάγετε ξανά.',
            },
            email: {
                requiredMsg: 'Λάθος μορφή email',
                patternMsg: 'Το email δεν είναι εγγεγραμμένο, Δημιουργήστε λογαριασμό',
            },
        },
        codeSuccess: 'Ο κωδικός επαλήθευσης έχει σταλεί, παρακαλούμε ελέγξτε.',
        success: 'Η αποστολή ολοκληρώθηκε',
        error: 'Αποτυχία αποστολής',
        loginSuccess: 'Επιτυχής σύνδεση',
        account: {
            accountTitle: 'Σύνδεση',
            registerTitle: 'Είσοδος',
            resetTitle: 'Ρύθμιση κωδικού πρόσβασης',
            password: 'Κωδικός',
            placeholder: 'Παρακαλώ εισάγετε τον κωδικό σας',
            codeLogin: 'Σύνδεση με κωδικό επαλήθευσης',
            accountLogin: 'Σύνδεση με κωδικό πρόσβασης',
            forgotPassword: 'Ξεχάσατε τον κωδικό πρόσβασης',
            registerTips:[
                'Δεν έχετε λογαριασμό', 
                'Είσοδος', 
                'Ο λογαριασμός υπάρχει ήδη',
                'Εγγραφή',
            ],
            checkRule: [
                '8-20 χαρακτήρες',
                'Πρέπει να περιέχει τουλάχιστον ένα κεφαλαίο γράμμα',
                'Πρέπει να περιέχει τουλάχιστον ένα πεζό γράμμα',
                'Πρέπει να περιέχει τουλάχιστον έναν αριθμό', 
                'Οι κωδικοί πρόσβασης δεν ταιριάζουν'
            ],
            errorTips: [
                'Λανθασμένος κωδικός πρόσβασης', 
                'Αποτυχία σύνδεσης', 
                'Ο λογαριασμός δεν υπάρχει'
            ],
            reset:[
                'Επαναφορά κωδικού πρόσβασης', 
                "Επόμενο βήμα",
                'Ο νέος κωδικός πρόσβασης δεν μπορεί να είναι ίδιος με τον προηγούμενο', 
                'Παράβλεψη',
                'Ο κωδικός πρόσβασης ρυθμίστηκε με επιτυχία'
            ],
            setPasswordTips:'Ο κωδικός πρόσβασης πρέπει να αποτελείται από 8 έως 20 χαρακτήρες και να περιλαμβάνει κεφαλαία γράμματα, πεζά γράμματα και αριθμούς.',
            confirmPassword: "Επιβεβαίωση Κωδικού",
        },
        switchButton: 'Σύνδεση με Κωδικό Πρόσβασης',
        switchButton1: 'Σύνδεση με κωδικό επαλήθευσης',
        loginTips: 'Οι μη εγγεγραμμένοι λογαριασμοί θα εγγράφονται αυτόματα μετά την επιτυχή σύνδεση.',
        otherLogin: 'Άλλοι Τρόποι Σύνδεσης',
        newEmailLogin: 'Σύνδεση με email',
        newPhoneLogin: 'Σύνδεση με αριθμό κινητού τηλεφώνου',
        bindLineTips:'Ή',
        bindEmail: 'Σύνδεση με Συνδεδεμένο Email',
        bindPhone: 'Σύνδεση με Συνδεδεμένο Αριθμό Τηλεφώνου',
        bindAndContinue: "Σύνδεση και συνέχεια",
        bind: "Σύνδεση",
        bindEmailTitle: 'Σύνδεση Email',
        bindEmailTips1: "Δεν βρέθηκε το email {item}",
        bindEmailTips2: "Συνδέστε email για συνέχεια",
        bindEmailTips3: "Δεν υπάρχει σύνδεση email. Συνδεθείτε για είσοδο και ανάκτηση κωδικού.",
        boundTitle: 'Έχετε εγγραφεί ξανά;',
        boundCenterTitle1:'Εάν είστε νέος χρήστης',
        boundCenterTips1:'Δημιουργήστε λογαριασμό για έναρξη',
        boundCenterTitle2:'Εάν έχετε ήδη λογαριασμό',
        boundCenterTips2:'Συνδέστε για συγχρονισμό δεδομένων',
        boundCenterTips3:'Παρακαλούμε συνδέστε έναν εγγεγραμμένο λογαριασμό',
        boundCenterTips4:'Συνιστάται',
        boundCenterTips5:'Σύνδεση {item} σε υπάρχοντα λογαριασμό',
        boundCenterTips6:'Δεδομένα και αναφορές θα συγχρονιστούν',
        boundButton1: 'Δημιουργία λογαριασμού με {item}',
        boundButton2: 'Σύνδεση υπάρχοντος λογαριασμού',
        phoneCode:"Είσοδος με κωδικό SMS",
        phonePassword:"Είσοδος με αριθμό κινητού και κωδικό πρόσβασης",
        emailCode:"Είσοδος με κωδικό Email",
        emailPassword:"Είσοδος με Email και κωδικό πρόσβασης",
        accountDoesNotExist:"Αυτός ο λογαριασμός δεν έχει εγγραφεί ακόμα. Παρακαλούμε ολοκληρώστε την εγγραφή με κωδικό επαλήθευσης email ή μέσω {item}.",
        toRegister:"Εγγραφείτε",
        bindNow: "Συνδέστε τώρα",
        bindError:[
            'Η Σύνδεση Απέτυχε',
            'Η Αποσύνδεση Επιτυχής',
            'Αποτυχία Αποσύνδεσης',
            'Αποτυχία Εξουσιοδότησης',
            'Αποτυχία Εξουσιοδότησης, αδύνατη η λήψη πληροφοριών λογαριασμού',
            'Επιτυχής Σύνδεση',
            'Ο λογαριασμός δεν υπάρχει. Συνδέστε έναν εγγεγραμμένο λογαριασμό.',
            'Η σύνδεση απέτυχε. Αυτός ο λογαριασμός είναι ήδη συνδεδεμένος με τον λογαριασμό {item} [{nickname}].',
            'Εξουσιοδοτημένη εγγραφή ως λογαριασμός, η αποσύνδεση δεν υποστηρίζεται',
            'Ο λογαριασμός δεν υπάρχει, παρακαλούμε χρησιμοποιήστε τον κωδικό επαλήθευσης για να συνδεθείτε και να εγγραφείτε',
        ],
        accountSecurity: {
            faceBook:'Λογαριασμός Facebook',
            google: 'Λογαριασμός Google',
            isBind: 'Δεν Έχει Συνδεθεί',
            dialogTitle: 'Επιβεβαίωση Αποσύνδεσης;',
            dialogCenter: 'Μετά την αποσύνδεση του {item}, δεν θα μπορείτε πλέον να το χρησιμοποιείτε για να συνδεθείτε σε αυτόν τον λογαριασμό.',
            bindFailure:'Η Σύνδεση Απέτυχε',
            bindFailureTips: 'Ο λογαριασμός σας {item} είναι ήδη συνδεδεμένος με τον παρακάτω λογαριασμό. Αν θέλετε να αλλάξετε τη σύνδεση στον τρέχοντα λογαριασμό, συνδεθείτε πρώτα στον παρακάτω λογαριασμό για να τον αποσυνδέσετε.',
            returnButton:'Επιβεβαίωση και Επιστροφή'
        },
        bindEmailError: [
            "邮箱请已存在，请更换邮箱。"
        ],

    },
    // 注册页面
    register: {
        mobileRegister: 'Τηλέφωνο',
        emailRegister: 'Email',
        enroll: 'Ο αριθμός τηλεφώνου είναι ήδη εγγεγραμμένος',
        enrollEmail: 'Email',
        search: 'Αναζήτηση',
        title: 'Οι λογαριασμοί κινητού τηλεφώνου και email είναι ανεξάρτητοι;παρακαλώ σημειώστε τον τύπο του λογαριασμού σας.',
        needRead: {
            agree: 'Συμφωνώ',
            privacy: '(Πολιτική Απορρήτου)',
        },
        register: 'Είσοδος',
        check: 'Ελέγξτε "Απορρήτο Χρήστη"',
        newUser: 'Είσοδος',
        form: {
            labelList: ['Όνομα', '* Φύλο', '* Ύψος', '* Ηλικία'],
        },
        placeholder: ['Παρακαλώ εισάγετε όνομα', 'Εισάγετε ύψος', 'Παρακαλώ εισάγετε ηλικία'],
        unit: ['μετρικό', 'αγγλικό', ''],
        sexOptions: {
            male: 'Άνδρας',
            female: 'Γυναίκα',
        },
        btn: 'Υποβολή',
        rules: {
            metricheight: [`Το εύρος ύψους είναι από 2'3'' - 6'7'', παρακαλώ εισάγετε το ξανά.`],
            heightMsg: [`Το εύρος ύψους είναι από 70 - 200cm, παρακαλώ εισάγετε το ξανά.`],
            ageMsg: [`Το εύρος ηλικίας είναι από 10 έως 99, παρακαλώ εισάγετε το ξανά.`],
            agePointMsg: ['Η ηλικία μπορεί να είναι μόνο ακέραιος αριθμός, παρακαλώ συμπληρώστε τη σωστή ηλικία.'],
        },
        success: 'Η εγγραφή πραγματοποιήθηκε με επιτυχία',
        userMessage: 'Εισαγωγή Ονόματος Χρήστη',
        verify: 'Εισαγωγή 4 Ψηφίων Κωδικού Επαλήθευσης',
        errorMsg: 'Η μορφή ύψους δεν υποστηρίζει δεκαδικά ψηφία, παρακαλώ εισάγετε το ξανά',
        abnormalMsg: 'Ανωμαλία Εγγραφής',
    },
    // 模型合成
    model: {
        loading: 'Φόρτωση... Παρακαλώ περιμένετε.',
        modelLoading: 'Φόρτωση Μοντέλου 3D...',
        tabPane: [
            {
                title: 'Τεχνολογία βαθιάς επίγνωσης οντοτήτων',
                msg: 'Συλλέξτε με ακρίβεια τοπικές λεπτομέρειες του σώματος μέσω τρισδιάστατης σάρωσης, εξασφαλίστε την ακρίβεια μέτρησης περιφέρειας σε επίπεδο χιλιοστού και παρουσιάστε ξεκάθαρα τις αλλαγές στο σχήμα του σώματος μετά την άσκηση.',
            },
            {
                title: 'Αλγόριθμος Σύνθεσης Σώματος BDA',
                msg: 'Το Visbody χρησιμοποιεί το πιο προηγμένο σύστημα μέτρησης σύνθεσης σώματος - τον αλγόριθμο BDA για τον προσδιορισμό της σύνθεσης του σώματος. Αυτή η μέθοδος υπολογισμού που βασίζεται στον όγκο του σώματος θα αξιολογήσει με ακρίβεια τους κινδύνους υγείας που προκαλούνται από την παχυσαρκία.',
            },
            {
                title: 'Παράγοντες που προκαλούν σφάλματα',
                msg: 'Τα χαλαρά ρούχα ή ορισμένα διακοσμητικά στο σώμα θα προκαλέσουν σφάλματα, παρακαλώ φορέστε εφαρμοστά ρούχα ή μειώστε την ποσότητα ρούχων στο σώμα σας εάν θέλετε να λάβετε τα πιο ακριβή δεδομένα.',
            },
            {
                title: 'Λάβετε την αναφορά σας',
                msg: 'Συνιστάται να προσθέσετε σελιδοδείκτη στη διεύθυνση URL της ιστοσελίδας για εύκολη προβολή της αναφοράς στο μέλλον.Μπορείτε επίσης να στείλετε αυτήν την αναφορά στο email σας για να την αποθηκεύσετε αργότερα.',
            },
        ],
        collect: ['Προσθέστε σελιδοδείκτη σε αυτή τη σελίδα, για εύκολη ανασκόπηση της αναφοράς στο μέλλον.', ''],
        know: 'Κατάλαβα',
        reminder: [
            'Ευγενική Υπενθύμιση',
            'Το 3D avatar μοντέλο σας έχει δημιουργηθεί, σύρετε αριστερά και δεξιά για να περιστρέψετε το μοντέλο.',
            'Η αναφορά σας έχει δημιουργηθεί και μπορείτε να την δείτε κάνοντας κλικ στο κουμπί "Προβολή Αναφοράς".',
            'Η αξιολόγηση του σώματός σας δεν είναι επιτυχής, παρακαλώ επανεξετάσε την αναφορά σύνθεσης σώματος.',
            'Η σύνθεση του σώματός σας δεν ήταν επιτυχής, παρακαλώ πολύ ανατρέξτε στην έκθεση αναφοράς αξιολόγησης της στάσης του σώματος .',
            'Η μέτρησή σας δεν είναι επιτυχής, παρακαλώ πηγαίνετε στη συσκευή και δοκιμάστε ξανά.~',
            'Η μέτρηση σύνθεσης σώματος δεν είναι επιτυχής, παρακαλώ πηγαίνετε στη συσκευή και δοκιμάστε ξανά.~',
            'Η αξιολόγηση στάσης δεν είναι επιτυχής, παρακαλώ πηγαίνετε στη συσκευή και δοκιμάστε ξανά.~',
        ],
        btn: {
            viewReport: 'Προβολή Αναφοράς',
            bodyReport: 'Προβολή Αναφοράς Σύνθεσης Σώματος',
            postureReport: 'Προβολή Αναφοράς Στάσης Σώματος',
            lastReport: 'Προβολή Τελευταίας Αναφοράς',
            loading: 'Φόρτωση...',
        },
    },
    // 报告
    report: {
        btn: {
            download: 'Λήψη Αναφοράς',
            send: 'Αποστολή Αναφοράς',
            report: 'Αποστολή Αναφοράς',
        },
        reportSuccess: 'Επιτυχία!',
        tabPane: {
            labelList: ['Χρόνος Μέτρησης', 'Στοιχείο', 'Σύσταση Σώματος', 'Αξιολόγηση Στάσης', 'Λειτουργία Ώμου'],
        },
        sendEmail: 'Ηλεκτονικό Ταχυδρομείο :',
        requiredMsg: 'Εισαγάγετε τη διεύθυνση email σας',
        patternMsg: 'Παρακαλώ εισάγετε τη σωστή διεύθυνση Email.',
        send: 'Αποστολή',
        download: 'Λήψη Αναφοράς',
        sendReport: 'Αποστολή Αναφοράς',
    },
    // 侧边栏
    sidebar: {
        successMsg: {
            sex: 'Το φύλο άλλαξε με επιτυχία',
            height: 'Το ύψος άλλαξε με επιτυχία',
            age: 'Η ηλικία άλλαξε με επιτυχία',
        },
        logOut: 'Αποσύνδεση',
        personal: 'Προσωπικό Κέντρο',
        cut: 'Εναλλαγή μονάδων/γλωσσών',
        changeSort: 'Αλλαγή Αναφοράς Προϊόντος',
        setPassword: 'Ρύθμιση/Αλλαγή κωδικού πρόσβασης',
        accountSecurity: 'Λογαριασμός και Ασφάλεια',
        describe: '* Μετά την αλλαγή του μοντέλου προϊόντος, θα εμφανιστούν όλες οι αναφορές μετρήσεων υπό αυτό το μοντέλο.',
        describeBtn: 'Μετά την αλλαγή του μοντέλου προϊόντος, θα ανακατευθυνθείτε στην πιο πρόσφατη αναφορά μέτρησης υπό αυτό το μοντέλο.',
        descReport: 'Επιτυχής Αλλαγή Αναφοράς Προϊόντος',
        unit: ['Μετρικό σύστημα μέτρησης(kg, cm)', 'Αγγλοσαξονικό σύστημα μέτρησης (ft, in, lb)'],
        read: {
            reading: 'Ανάγνωση',
            privacy: '(Πολιτική Απορρήτου)',
        },
        setting: 'Ρυθμίσεις',
        form: {
            labelList: ['Τηλέφωνο', 'Μονάδα', 'Γλώσσες', 'Ψευδώνυμο', 'Φύλο', 'Ύψος', 'Ηλικία'],
        },
        placeholder: ['Αλλαγή Ονόματος Χρήστη', 'Νέο Φύλο', 'Το Ύψος Ενημερώθηκε', 'Η Ηλικία Ενημερώθηκε'],
        btn: {
            cancelBtn: 'Άκυρο',
            accomplishBtn: 'Ολοκλήρωση',
            confirmBtn: 'Εντάξει',
        },
        dialog: [
            'Το φύλο είναι ένα από τα πιο σημαντικά κριτήρια για τη μέτρηση της σύστασης του σώματος.Τα δεδομένα που μετρήθηκαν μετά την τροποποίηση θα είναι διαφορετικά από τα προηγούμενα δεδομένα. Επιβεβαιώστε εάν θέλετε να κάνετε αλλαγή.',
            'Το ύψος είναι ένα από τα πιο σημαντικά κριτήρια για τη μέτρηση της σύστασης του σώματος. Τα δεδομένα που μετρήθηκαν μετά την τροποποίηση θα είναι διαφορετικά από τα προηγούμενα δεδομένα. Επιβεβαιώστε εάν θέλετε να κάνετε αλλαγή.',
            'Η ηλικία είναι ένα από τα πιο σημαντικά κριτήρια για τη μέτρηση της σύστασης του σώματος. Τα δεδομένα που μετρήθηκαν μετά την τροποποίηση θα είναι διαφορετικά από τα προηγούμενα δεδομένα. Επιβεβαιώστε εάν θέλετε να κάνετε αλλαγή.',
        ],
        rules: {
            metricheight: [`Παρακαλώ συμπληρώστε το σωστό εύρος ύψους (2'3" έως 6'7").`],
            heightMsg: ['Παρακαλώ συμπληρώστε το ύψος εντός 70cm - 200cm'],
            ageMsg: ['Παρακαλώ συμπληρώστε την ηλικία εντός 10 - 99 ετών.'],
        },
        heightMsg: 'Παρακαλώ Επιλέξτε Ξανά το Ύψος',
        ageMsg: 'Παρακαλώ Επιλέξτε Ξανά την Ηλικία',
        ModelBinding: 'Φαίνεται ότι κάποιος έχει ήδη σαρώσει τον κωδικό, παρακαλώ μετρήστε ξανά!',
        ReportEmpty: {
            title: 'Δεν έχετε καμία αναφορά ακόμα.',
            desc: 'Ελάτε στο σαρωτή σώματος 3D της Visbody και δοκιμάστε ξανά!',
        },
    },
    // 无测量报告
    modelBinding: {
        desc: 'Φαίνεται ότι κάποιος έχει ήδη σαρώσει τον κωδικό, παρακαλώ μετρήστε ξανά!',
    },
    // 扫码模型已被绑定
    reportEmpty: {
        title: 'Δεν έχετε καμία αναφορά ακόμα.',
        desc: 'Ελάτε στο σαρωτή σώματος 3D της Visbody και δοκιμάστε ξανά!',
        descS30: '找到 Visbody-S30 3D 体测精灵，进行一次测量吧！',
        descM30: '找到 Visbody-M30 3D 体测精灵，进行一次测量吧！',
    },
    // 用户信息
    userInfo: {
        height: 'Ύψος:',
        age: 'Ηλικία:',
        unit: '',
        weight: 'Βάρος',
    },
    // 体成分
    mass: {
        title: 'Επισκόπηση Αξιολόγησης Σύνθεσης Σώματος',
        titles: 'Σύνθεση Σώματος',
        springFrame: '',
        massFrame: 'Δεν υπάρχουν δεδομένα μέτρησης για την ημέρα',
        contrast: 'Επιλέξτε μια αναφορά για σύγκριση',
        contrastReport: 'Επιλέξτε μια αναφορά για σύγκριση',
        noRecord: 'Κενό',
        score: 'Βαθμολογία',
        status: 'Η τρέχουσα κατάσταση της σύνθεσης του σώματός σας',
        WT: 'Βάρος',
        PBF: 'Ποσοστό Λίπους',
        endSymbol: '.',
        // 测量相关
        measure: {
            value: 'Τιμές',
            standardRange: 'Τυπικό Εύρος',
            comparedWithLastLime: 'Καθαρό',
            comparedNet: 'Καθαρό',
            current: 'Τρέχουσα βαθμολογία μέτρησης',
            WT: 'Βάρος',
            FFM: 'Άπαχη Μάζα',
            BFM: 'Λιπώδης Μάζα',
            LM: 'Μυϊκή Μάζα',
            TBW: 'Συνολικό Νερό',
            SM: 'Σκελετικοί Μύες',
            PROTEIN: 'Πρωτεΐνη',
            TM: 'Ανόργανα Άλατα',
            BMR: 'Βασικός Μεταβολισμός',
            WHR: 'Αναλογία Μέσης-Ισχίου',
            BMI: 'ΔΜΣ',
            PBF: 'Ποσοστό Λίπους',
            VFG: 'Επίπεδο Σπλαχνικού Λίπους',
            unit: 'κιλά',
            BMRUnit: 'kcal/ ημέρα',
        },
        // 定义解读
        explain: [
            {
                title: 'Βάρος',
                msg: 'Το βάρος είναι το άθροισμα νερού, πρωτεΐνης, αλάτων και λίπους σώματος.',
            },
            {
                title: 'Άπαχη Μάζα',
                msg: 'Η άλιπη μάζα είναι το βάρος χωρίς λίπος.',
            },
            {
                title: 'Λιπώδης Μάζα',
                msg: 'Το σωματικό λίπος είναι το άθροισμα υποδόριου, σπλαχνικού και ενδομυϊκού λίπους.',
            },
            {
                title: 'Μυϊκή Μάζα',
                msg: 'Η μυϊκή μάζα περιλαμβάνει σκελετικούς, λείους και καρδιακούς μύες.',
            },
            {
                title: 'Συνολικό Νερό',
                msg: 'Το νερό αποτελεί 50-70% του σώματος, κυρίως στα κύτταρα και υγρά, με το περισσότερο στους μύες.',
            },
            {
                title: 'Σκελετικοί Μύες',
                msg: 'Οι σκελετικοί μύες (ή γραμμωτοί) προσκολλώνται στα οστά. Εδώ υπολογίζεται η ποσότητά τους.',
            },
            {
                title: 'Πρωτεΐνη',
                msg: 'Η πρωτεΐνη, αζωτούχα στερεά ουσία, υπάρχει σε όλα τα κύτταρα και είναι κύριο συστατικό των μυών.',
            },
            {
                title: 'Ανόργανα Άλατα',
                msg: 'Το σώμα αποτελείται από οργανική, ανόργανη ύλη και νερό. Τα ανόργανα άλατα αποτελούν το 5% του βάρους.',
            },
            {
                title: 'Βασικός Μεταβολισμός',
                msg: 'Ο βασικός μεταβολισμός είναι η ενέργεια που καταναλώνεται σε κατάσταση ηρεμίας, χωρίς εξωτερικές επιδράσεις.',
            },
            {
                title: 'Αναλογία Μέσης-Ισχίου',
                msg: 'Η αναλογία μέσης-ισχίου είναι δείκτης κεντρικής παχυσαρκίας.',
            },
            {
                title: 'ΔΜΣ',
                msg: 'Ο ΔΜΣ αξιολογεί την παχυσαρκία και είναι διεθνές πρότυπο μέτρησης σωματικού λίπους.',
            },
            {
                title: 'Ποσοστό Λίπους',
                msg: 'Το ποσοστό σωματικού λίπους είναι η αναλογία λίπους στο συνολικό βάρος.',
            },
            {
                title: 'Επίπεδο Σπλαχνικού Λίπους',
                msg: 'Ο βαθμός σπλαχνικού λίπους είναι ένας σημαντικός δείκτης για την αξιολόγηση της κρυφής παχυσαρκίας.',
            },
            {
                title: 'Ενδοκυττάριο νερό',
                msg: 'Ενδοκυτταρικό Νερό : Είναι το σωματικό υγρό που περιέχεται στα κύτταρα του σώματος και αποτελεί το βασικό συστατικό του πρωτοπλάσματος.',
            },
            {
                title: 'Εξωκυττάριο νερό',
                msg: 'Εξωκυτταρικό Νερό : Συνήθως αναφέρεται σε εξωκυτταρικά σωματικά υγρά, συμπεριλαμβανομένου του πλάσματος και του ενδιάμεσου υγρού μεταξύ των αιμοφόρων αγγείων και των κυττάρων των ιστών.',
            },
            {
                title: 'Μεταβολική ηλικία',
                msg: 'Η μεταβολική ηλικία αφορά την απόδοση του σώματος και τις λειτουργίες υγείας που σχετίζονται με τον μεταβολισμό.',
            },
            {
                title: 'Αναλογία ECW/TBW',
                msg: 'Η αναλογία ECW/TBW είναι το ποσοστό του εξωκυττάριου νερού (ECW) στο συνολικό νερό του σώματος (TBW). Αποτελεί σημαντικό δείκτη για την αξιολόγηση της ισορροπίας υγρών του σώματος.',
            },
        ],
        // 节段
        segment: {
            fat: 'Κατανομή λίπους ανά τμήμα',
            muscle: 'Κατανομή μυϊκής μάζας ανά τμήμα',
            right: 'Δεξιά',
            left: 'Αριστερά',
            standard: 'Κανονικός',
            lowStandard: 'Κάτω από',
            superStandard: 'Πάνω',
            peel: '(απόβαρο)',
        },
    },
    // 体态
    shape: {
        title: 'Επισκόπηση Αξιολόγησης Σώματος',
        titles: 'Στάση',
        status: 'Η τρέχουσα φυσική κατάστασή σας',
        suggest: 'Πρόταση',
        possibility: ', υπάρχει πιθανότητα για',
        models: {
            front: 'Θετικός',
            left: 'Αριστερό προφίλ',
            right: 'Δεξί προφίλ',
            top: 'Πίσω',
            low: 'Κάτω Από',
            high: 'Πάνω Από',
            normal: 'Φυσιολογικό',
        },
        item: {
            deviate: 'Τιμές',
            result: 'Εξήγηση',
            normal: 'Φυσιολογικό',
			keAbnormal: 'Πιθανή ανωμαλία',
            abnormal: 'Μη κανονικός',
            head: 'Πρόσθια Κλίση Κεφαλής',
            headSlant: 'Πλάγια Κλίση Κεφαλής',
            roundShoulderLeft: 'Κύρτωση Αριστερού Ώμου',
            roundShoulderRight: 'Κύρτωση Δεξιού Ώμου',
            highLowShoudler: 'Ασύμμετροι Ώμοι',
            pelvis: 'Πρόσθια/Οπίσθια Κλίση Λεκάνης',
            leftKneeCheck: 'Αξιολόγηση Αρ. Γονάτου',
            rightKneeCheck: 'Αξιολόγηση Δεξ. Γονάτου',
            leg: 'Τύπος Ποδιών',
            leftLeg: 'Αρ. πόδι:',
            rightLeg: 'Δεξ. πόδι:',
        },
        // 定义解读
        explain: [
            {
                title: 'Πρόσθια Κλίση Κεφαλής',
                msg: 'Η γωνία μεταξύ του σημείου του αυτιού στην αριστερή πλευρά και της γραμμής που συνδέει το κέντρο του λαιμού και της μέσης γραμμής στο πλάι',
            },
            {
                title: 'Πλάγια Κλίση Κεφαλής',
                msg: 'Η γωνία μεταξύ του αριστερού σημείου του αυτιού και της κεντρικής γραμμής του λαιμού και της μέσης γραμμής της πλευράς',
            },
            {
                title: 'Κύρτωση Αριστερού Ώμου',
                msg: 'Η γωνία μεταξύ του υψηλότερου σημείου της αριστερής πλευράς της πλάτης και της εφαπτομένης γραμμής του ώμου',
            },
            {
                title: 'Κύρτωση Δεξιού Ώμου',
                msg: 'Η γωνία μεταξύ του υψηλότερου σημείου της δεξιάς πλευράς της πλάτης και της εφαπτομένης γραμμής του ώμου',
            },
            {
                title: 'Ασύμμετροι Ώμοι',
                msg: 'Η κάθετη απόσταση μεταξύ των σημείων του αριστερού και δεξιού ώμου με την πλάτη',
            },
            {
                title: 'Πρόσθια/Οπίσθια Κλίση Λεκάνης',
                msg: 'Η γωνία που συμπεριλαμβάνει τα τρία σημεία και συνδέει το κέντρο του λαιμού , το σημείο του ισχίου και το σημείο του αστραγάλου στην αριστερή πλευρά .',
            },
            {
                title: 'Αξιολόγηση Αρ. Γονάτου',
                msg: 'Η γωνία της γραμμής τριών σημείων που συνδέει το οστό του ισχίου, την άρθρωση του γόνατος και το σημείο του αστραγάλου στην αριστερή πλευρά',
            },
            {
                title: 'Αξιολόγηση Δεξ. Γονάτου',
                msg: 'Η γωνία της γραμμής τριών σημείων που συνδέει το οστό του ισχίου, την άρθρωση του γόνατος και το σημείο του αστραγάλου στη δεξιά πλευρά',
            },
            {
                title: 'Τύπος Ποδιών',
                msg: 'Η γωνία μεταξύ των σημείων των οστών του ισχίου, των αρθρώσεων του γόνατος και των σημείων του αστραγάλου στο μπροστινό μέρος του αριστερού και του δεξιού ποδιού',
            },
            {
                title: 'Πρόσθια/οπίσθια κλίση πυέλου',
                msg: 'Η γωνία μεταξύ της κατακόρυφης και του τριγώνου που σχηματίζεται από τις Πρόσθιες Άνω Λαγόνιες Άκανθες και τη Ηβική Σύμφυση.'
            },
            {
                title: 'Ανισοσκελία',
                msg: 'Η διαφορά ύψους από το έδαφος μεταξύ των χαμηλότερων σημείων της αριστερής και της δεξιάς γλουτιαίας πτυχής.'
            }
        ],
        exception: [
            {
                title: 'Κλίση προς την Αριστερή Πλευρά',
                abnormal: '',
            },
            {
                title: 'Κλίση προς τη Δεξιά Πλευρά',
                abnormal: '',
            },
            {
                title: 'Αριστερά ψηλά',
                abnormal: '',
            },
            {
                title: 'Δεξιά ψηλά',
                abnormal: '',
            },
            {
                title: 'Οπίσθια Κλίση της Λεκάνης',
                abnormal: '',
            },
            {
                title: 'Εμπρόσθια Κλίση της Λεκάνης',
                abnormal: '',
            },
            {
                title: 'Υπερέκταση του Αριστερού Γόνατου',
                abnormal: '',
            },
            {
                title: 'Αριστερό Γόνατο Κάμψη Προς Τα Εμπρος',
                abnormal: '',
            },
            {
                title: 'Υπερέκταση του Δεξιού Γόνατου',
                abnormal: '',
            },
            {
                title: 'Δεξί Γόνατο Κάμψη Προς Τα Εμπρος',
                abnormal: '',
            },
            {
                title: 'Πόδια σε Σχήμα Κ',
                abnormal: '',
            },
            {
                title: 'Πόδια σε Σχήμα D',
                abnormal: '',
            },
            {
                title: 'Πόδια σε Σχήμα Χ',
                abnormal: '',
            },
            {
                title: 'Πόδια σε Σχήμα Ο',
                abnormal: '',
            },
            {
                title: 'Πρόσθια Κλίση Πυέλου',
                abnormal: ''
            },
            {
                title: 'Οπίσθια Κλίση Πυέλου',
                abnormal: ''
            },
            {
                title: 'Diskrepansi abnormal (kiri lebih panjang)',
                abnormal: ''
            },
            {
                title: 'Diskrepansi abnormal (kanan lebih panjang)',
                abnormal: ''
            }
        ],
    },
    newshape: {
        explain: [
            {
                msg: 'Κάθετη απόσταση μεταξύ των αυτιών και της γραμμής βαρύτητας του σώματος',
            },
            {
                msg: 'Γωνία μεταξύ της γραμμής που συνδέει τα δύο αυτιά και του οριζόντιου επιπέδου',
            },
            {
                msg: 'Κάθετη απόσταση μεταξύ της αριστερής ακρωμιακής απόφυσης και της γραμμής βαρύτητας',
            },
            {
                msg: 'Κάθετη απόσταση μεταξύ της δεξιάς ακρωμιακής απόφυσης και της γραμμής βαρύτητας',
            },
            {
                msg: 'Διαφορά στις γραμμές μεταξύ της βάσης του αυχένα και των ακρωμιακών αποφύσεων',
            },
            {
                msg: 'Κάθετη απόσταση άρθρωσης ισχίου και γραμμής βαρύτητας',
            },
            {
                msg: 'Γωνία στον οβελιαίο επίπεδο μεταξύ ποδοκνημικής και γόνατος αριστερού',
            },
            {
                msg: 'Γωνία στον οβελιαίο επίπεδο μεταξύ ποδοκνημικής και γόνατος δεξιού',
            },
            {
                msg: 'Γωνία μεταξύ των αμφοτερόπλευρων αρθρώσεων του ισχίου, των γονάτων και των αστραγάλων στο μετωπιαίο επίπεδο',
            },
        ],
        item: {
            pelvis: 'Πρόσθια κλίση της πυέλου',
        },
    },
    // 围度信息
    girth: {
        title: 'Περίμετροι',
        present: '(Παρόν)',
        noHistory: 'Χωρίς δεδομένα.',
        tpl: [
            {
                title: 'Περίμετρος Λαιμού',
                key: 'neckGirth',
            },
            {
                title: 'Περ. Αρ. Βραχίονα',
                key: 'leftUpperArmGirth',
            },
            {
                title: 'Περ. Δεξ. Βραχίονα',
                key: 'rightUpperArmGirth',
            },
            {
                title: 'Περ. Στήθους',
                key: 'bustGirth',
            },
            {
                title: 'Περ. Άνω Μέσης',
                key: 'waistGirth',
            },
            {
                title: 'Περ. Μέσης',
                key: 'midWaistGirth',
            },
            {
                title: 'Περ. Γοφών',
                key: 'hipGirth',
            },
            {
                title: 'Περ. Αρ. Μηρού',
                key: 'leftThighGirth',
            },
            {
                title: '左大腿中部围',
                key: 'leftMidThighGirth',
            },
            {
                title: 'Ελάχ. Περ. Αρ. Μηρού',
                key: 'leftMinThighGirth',
            },
            {
                title: 'Περ. Δεξ. Μηρού',
                key: 'rightThighGirth',
            },
            {
                title: '右大腿中部围',
                key: 'rightMidThighGirth',
            },
            {
                title: 'Ελάχ. Περ. Δεξ. Μηρού',
                key: 'rightMinThighGirth',
            },
            {
                title: 'Περ. Αρ. Κνήμης',
                key: 'leftCalfGirth',
            },
            {
                title: 'Περ. Δεξ. Κνήμης',
                key: 'rightCalfGirth',
            },
            {
                title: 'Χαμηλή μέση',
                key: 'lowWaistGirth',
            },
        ],
    },
    // 肩部
    shoulder: {
        title: 'Λειτουργία Ώμου',
        model: {
            val: 'Τιμές',
            scope: 'Τοποθεσία μέγιστης δραστηριότητας',
            diff: 'Καθαρό',
        },
        normal: 'Φυσιολογικό',
        normalAll: 'Δεν εντοπίστηκαν σημαντικές ανωμαλίες στη λειτουργία των ώμων.',
        conclusion: 'Συμπέρασμα',
        analyse: 'Ανάλυση: ',
        suggest: 'Πρόταση: ',
        cause: 'Παρακαλώ συμβουλευτείτε με ειδικούς για λεπτομερείς λόγους.',
    },
    reportTips: {
        title: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την αναφορά; Δεν μπορεί να ανακτηθεί μετά τη διαγραφή.",
        confirm: "Διαγραφή",
        success: "Η αναφορά διαγράφηκε",
        partial: "Η αναφορά διαγράφηκε, μέρος των δεδομένων δεν συγχρονίστηκε επιτυχώς. Παρακαλούμε επικοινωνήστε με τον διαχειριστή.",
        failed: "Η διαγραφή απέτυχε, παρακαλούμε επαναλάβετε αργότερα",
        btnMsg: 'Εντάξει',
        alaryTips: 'Αυτή η αναφορά διαγράφηκε από τον διαχειριστή και θα μεταφερθείτε στην επόμενη αναφορά!',
    },
    saveQr: {
        title: 'Αναφορά Σαρωτή Σώματος 3D Visbody',
        btnMsg: 'Κρατήστε πατημένη την εικόνα για να την αποθηκεύσετε στο τηλέφωνό σας.',
        tips: 'Αν δεν μπορείτε να αποθηκεύσετε, παρακαλούμε πηγαίνετε στις [Ρυθμίσεις] και ανοίξτε τις αντίστοιχες άδειες.',
    },
    vanCalendar: {
        end: 'End',
        start: 'Start',
        title: 'Calendar',
        startEnd: 'Start/End',
        weekdays: ['Κυρ', 'Δευ', 'Τρι', 'Τετ', 'Πεμ', 'Παρ', 'Σαβ'],
        monthTitle: function monthTitle(year, month) {
            return year + '/' + month
        },
        rangePrompt: function rangePrompt(maxRange) {
            return 'Choose no more than ' + maxRange + ' days'
        },
    },
    share: {
        title: 'Παρακαλούμε αντιγράψτε και κοινοποιήστε τον παρακάτω σύνδεσμο.',
        btnMsg: 'Αντιγραφή',
    },
    'bodyPrediction': {
		'body-title': 'Πρόβλεψη σχήματος σώματος',
		'body-yu-ce-status': 'Πρόβλεψη με βάση την τρέχουσα κατάσταση',
		'body-setting': 'Ρυθμίσεις πρόβλεψης σώματος',
		'body-li-xiang': 'Ιδανική τιμή:',
		'body-ti-zhong': 'Βάρος',
		'body-ti-zhi-lv': 'Ποσοστό Λίπους',
		'body-ji-rou': 'Μυϊκή μάζα',
		'yu-che-pre': 'Πριν',
		'yu-che-after': 'Μετά',
		'zan-model-no': 'Δεν υπάρχει διαθέσιμο μοντέλο',
		'ti-xing-error': 'Αποτυχία σύνθεσης αποτελεσμάτων πρόβλεψης~~',
		'ti-xing-worker-error': 'Φαίνεται ότι οφείλεται σε πρόβλημα δικτύου~',
		'ti-xing-adjust': 'Ποσό προσαρμογής',
		'ji-rou-title': 'Μυϊκή Μάζα',
		'ti-zi-fang': 'Σωματικό λίπος',
		'dang-pre-zhi': 'Τρέχουσα τιμή:',
		'nen-zhang': 'Τρέχουσα τιμή:',
		'nen-zhang-title': 'Επεξήγηση περιοχής σπλαχνικού λίπους',
		'nen-zhang-title1': 'Το σπλαχνικό λίπος βρίσκεται ανάμεσα στα εσωτερικά όργανα και μπορεί να οδηγήσει σε κοιλιακή παχυσαρκία. Η περιοχή σπλαχνικού λίπους αντιπροσωπεύει την εγκάρσια τομή αυτού του λίπους.'
	},
    wifi: {
        'title': 'Ρυθμίσεις Wi-Fi',
        'tips': 'Παρακαλώ εισάγετε τον κωδικό πρόσβασης για το ακόλουθο δίκτυο Wi-Fi',
        'password':'Κωδικός Wi-Fi',
        'password-placeholder': 'Εισάγετε τον κωδικό Wi-Fi',
        'password-tips': 'Ο κωδικός πρόσβασης κάνει διάκριση πεζών-κεφαλαίων, βεβαιωθείτε ότι τον εισάγετε σωστά',
        'button': 'Δημιουργία κωδικού QR',
        'h5-title': 'Διαμόρφωση πληροφοριών Wi-Fi',
        'wifi-name': 'Όνομα Wi-Fi:',
        'wifi-password': 'Κωδικός Wi-Fi:',
        'wifi-qr-tips1': '* Επιβεβαιώστε ότι το όνομα και ο κωδικός πρόσβασης Wi-Fi είναι σωστά και, στη συνέχεια, ευθυγραμμίστε τον κωδικό QR με την κάμερα που βρίσκεται κάτω από την οθόνη για σάρωση.',
        'wifi-qr-tips2': 'Ευθυγραμμίστε τον κωδικό QR Wi-Fi με την κάμερα κάτω από την οθόνη για σάρωση',
        'wifi-qr-button': 'Επιστροφή',
    },
    "waist": {
    "title": "Μέτρηση περιμέτρου μέσης και κοιλιάς",
    "hou": "Πίσω",
    "qian": "Όψη"
  },
    "yao_wei_1": "Μέση",
    "yao_bu_fen_shu": "Βαθμολογία μέσης",
    "waist_fen": "Βαθμολογία",
    "yao_wei": "Περίμετρος μέσης",
    "yao_wei_jian_ti_ji": "Όγκος μεταξύ περιφέρειας μέσης",
    "yao_tun_bi": "Αναλογία Μέσης-Ισχίου",
    "lun_kuo_fen_xi": "Ανάλυση περιγράμματος",
    "bei_bu": "Πλάτη",
    "tunbu": "Γλουτοί",
    "bei_bu_ti_ji": "Όγκος πλάτης",
    "zheng_chang_fan_wei": "Rentang normal:",
    "shang_ci": "Προηγ. ",
    "ben_ci": "Τώρα ",
    "gupen": {
        "zheng_chang": "Φυσιολογικό",
        "qian_qin_yan_chang": "Anteversio abnormal",
        "qian_qin_yi": "Risiko anteversio",
        "hou_qin_yi": "Risiko retroversio",
        "hou_qin_yan_chang": "Retroversio abnormal",
        "zuo_chang_yan_chang": "Diskrepansi abnormal (kiri lebih panjang)",
        "zuo_chang_yi": "Risiko diskrepansi (kiri lebih panjang)",
        "you_chang_yi": "Risiko diskrepansi (kanan lebih panjang)",
        "you_chang_yan_chang": "Diskrepansi abnormal (kanan lebih panjang)"
    },
    "gao_yao_xian": "Περ. Άνω Μέσης",
    "gao_yao_zhong_xian": "Κεντρική Γραμμή Ψηλής Μέσης",
    "gao_yao_xia_xian": "Κάτω Γραμμή Ψηλής Μέσης",
    "xiao_yao_shang_xian": "Άνω Γραμμή Χαμηλής Μέσης",
    "xiao_yao_zhong_xian": "Κεντρική Γραμμή Χαμηλής Μέσης",
    "xiao_yao_xian": "Χαμηλή μέση",
    "qv_jian1": "Bagian Atas Pinggang Tinggi",
    "qv_jian2": "Bagian Bawah Pinggang Tinggi",
    "qv_jian_zhong": "Bagian Pinggang Tengah",
    "qv_jian3": "Bagian Atas Pinggang Rendah",
    "qv_jian4": "Bagian Bawah Pinggang Rendah",
    "celiang.failed": "Η μέτρηση απέτυχε, παρακαλούμε φορέστε εφαρμοστά ρούχα και παραμείνετε ακίνητοι κατά τη διάρκεια της μέτρησης",
    ...elLocale,
    ...agrEn,
    "jie-gou-yi-chang-ping-gu": "Αξιολόγηση Δομικών Ανωμαλιών",
    "teng-tong-feng-xian-ping-gu": "Αξιολόγηση Κινδύνου Πόνου",
    "zheng-chang": "Νόρμαλ",
    "qing-du-yi-chang": "Ήπια Ανωμαλία",
    "zhong-du2-yi-chang": "Μέτρια ανωμαλία",
    "zhong-du-yi-chang": "Σοβαρή Ανωμαλία",
    "pen-gu-zhuan-xiang-feng-xian-ping-gu": "Αξιολόγηση Κινδύνου της Πυελικής Υγείας",
    "qian-qing": "Πρόσθια Κλίση",
    "hou-qing": "Οπίσθια Κλίση",
    "xuan-zhuan": "Στροφή",
    "pen-gu-qian-qing-feng-xian-fen-shu": "Βαθμολογία Κινδύνου Πρόσθιας Κλίσης Πυέλου",
    "pen-gu-hou-qing-feng-xian-fen-shu": "Βαθμολογία Κινδύνου Οπίσθιας Κλίσης Πυέλου",
    "pen-gu-xuan-zhuan-feng-xian-fen-shu": "Βαθμολογία Κινδύνου Στροφής Πυέλου",
    "fen": "Βαθμολογία",
    "gao-feng-xian": "Υψηλός Κίνδυνος",
    "ji-rou-ping-gu-jie-guo": "Αποτελέσματα Αξιολόγησης Μυών",
    "qian-qing-feng-xian-gao": "Υψηλός Κίνδυνος Πρόσθιας Κλίσης",
    "hou-qing-feng-xian-gao": "Υψηλός Κίνδυνος Οπίσθιας Κλίσης",
    "xuan-zhuan-feng-xian-gao": "Υψηλός Κίνδυνος Στροφής",
    "qia-yao-ji-shu-ji-ji-xia-bu-jin-zhang-fu-heng-ji-bao-ruo": "Σφιγμένος λαγονοψοΐτης/κατώτερος εκτείνων της σπονδυλικής στήλης, αδύναμος εγκάρσιος κοιλιακός.",
    "gu-hou-ji-qun-tun-ji-shu-ji-ji-jin-zhang-qia-yao-ji-ruo": "Σφιγμένοι οπίσθιοι μηριαίοι, γλουτοί και εκτείνων της σπονδυλικής στήλης, αδύναμος λαγονοψοΐτης.",
    "dan-ce-tun-zhong-ji-bao-ruo-yao-fang-ji-bu-ping-heng": "Μονομερής αδυναμία του μέσου γλουτιαίου / ανισορροπία του τετράγωνου οσφυϊκού μυός.",
    "gu-pen-xiang-guan-ji-rou-ping-gu-zheng-chang-qing-ji-xu-bao-chi-liang-hao-de-sheng-huo-xi-guan": "Η αξιολόγηση των μυών της πυέλου είναι φυσιολογική. Παρακαλούμε συνεχίστε να διατηρείτε έναν υγιεινό τρόπο ζωής.",
    "yi-shang-xiang-mu-jun-zheng-chang": "Όλα τα παραπάνω στοιχεία είναι φυσιολογικά.",
    "ji-zhu-jie-gou-yi-chang-ping-gu": "Αξιολόγηση Δομικών Ανωμαλιών της Σπονδυλικής Στήλης",
    "zheng-ti-ping-fen": "Συνολική Βαθμολογία",
    "jing-zhui": "Αυχενική μοίρα",
    "xiong-zhui": "Θωρακική μοίρα",
    "yao-zhui": "Οσφυϊκή μοίρα",
    "jing-zhui-jie-gou-yi-chang-ping-fen": "Βαθμολογία Ανωμαλίας Αυχενικής Μοίρας",
    "xiong-zhui-jie-gou-yi-chang-ping-fen": "Βαθμολογία Ανωμαλίας Θωρακικής Μοίρας",
    "yao-zhui-jie-gou-yi-chang-ping-fen": "Βαθμολογία Ανωμαλίας Οσφυϊκής Μοίρας",
    "jing-zhui-ji-rou-ping-gu": "Αξιολόγηση Μυών Αυχενικής Μοίρας",
    "xiong-zhui-ji-rou-ping-gu": "Αξιολόγηση Μυών Θωρακικής Μοίρας",
    "yao-zhui-ji-rou-ping-gu": "Αξιολόγηση Μυών Οσφυϊκής Μοίρας",
    "ji-zhu-zheng-ti-pai-lie-ji-ben-zheng-chang": "Η συνολική ευθυγράμμιση της σπονδυλικής στήλης είναι γενικά φυσιολογική.",
    "tou-bu-zi-tai-he-jing-zhui-pai-lie-ji-ben-zheng-chang": "Η στάση της κεφαλής και η ευθυγράμμιση της αυχενικής μοίρας είναι εντός φυσιολογικών ορίων.",
    "cun-zai-ming-xian-de-tou-bu-qian-qing-huo-ce-wai-jing-zhui-pai-lie-qing-du-pian-yi": "Ελαφριά απόκλιση αυχένα με προβολή/κλίση κεφαλής. Προσοχή στη στάση καθίσματος.",
    "tou-bu-ming-xian-qian-qing-huo-ce-wai-jing-zhui-pai-lie-zhong-du-pian-yi": "Απόκλιση αυχένα με προβολή/κλίση κεφαλής. Συνιστάται έλεγχος στάσης και προπόνηση.",
    "tou-bu-yan-zhong-qian-qing-huo-ce-wai-jing-zhui-pai-lie-yan-zhong-pian-yi": "Σημαντική απόκλιση αυχένα και κεφαλής. Συνιστάται επαγγελματική αξιολόγηση.",
    "xiong-zhui-pai-lie-ji-ben-zheng-chang-wu-ming-xian-jie-gou-yi-chang": "Η ευθυγράμμιση της θωρακικής μοίρας είναι γενικά φυσιολογική, χωρίς σημαντικές δομικές ανωμαλίες.",
    "xiong-zhui-pai-lie-qing-du-pian-yi-ke-neng-dui-sheng-huo-zhi-liang-you-qing-wei-ying-xiang": "Ελαφριά θωρακική απόκλιση. Συνιστάται βελτίωση ελέγχου στάσης.",
    "xiong-zhui-pai-lie-zhong-du-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Θωρακική απόκλιση που επηρεάζει τη σταθερότητα. Συνιστάται στοχευμένη προπόνηση.",
    "xiong-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang-ke-neng-zao-cheng-teng-tong-ji-qi-ta-ji-fa-xing-wen-ti": "Εμφανής θωρακική απόκλιση και ασυμμετρία. Συνιστάται επαγγελματική διόρθωση.",
    "yao-zhui-pai-lie-zheng-chang-zi-shi-ping-heng-wu-ming-xian-jie-gou-yi-chang": "Η ευθυγράμμιση της οσφυϊκής μοίρας είναι φυσιολογική με ισορροπημένη στάση και χωρίς σημαντικές δομικές ανωμαλίες.",
    "yao-zhui-pai-lie-qing-du-pian-yi-sheng-wu-li-xian-shang-ke-dan-chang-qi-ke-neng-yin-fa-zi-shi-dai-chang": "Ελαφριά οσφυϊκή απόκλιση, ισορροπημένη στάση. Συνιστάται σταθεροποίηση κορμού.",
    "yao-zhui-pai-lie-zhong-du-pian-yi-sheng-wu-li-xian-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Οσφυϊκή απόκλιση που επηρεάζει τη σταθερότητα. Συνιστάται διορθωτική προπόνηση.",
    "yao-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang": "Εμφανής οσφυϊκή απόκλιση. Συνιστάται επαγγελματικό σχέδιο βελτίωσης.",
    "jian-jia-ti-ji-xiong-suo-ru-tu-ji-he-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-jing-shen-qu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-jing-bu-ji-rou-bing-jin-hang-shen-zhan-yun-dong": "Υπερτονία: ανελκτήρας ωμοπλάτης, SCM, άνω τραπεζοειδής. Αδυναμία: εν τω βάθει καμπτήρες αυχένα. Συνιστάται σταθεροποίηση/χαλάρωση.",
    "zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolorred-jin-zhang-span-you-ce-xiong-suo-ru-tu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Υπερτονία: αριστερός SCM και οπίσθιος σκαληνός. Αδυναμία: δεξιός SCM. Συνιστάται αμφοτερόπλευρη ισορροπία/χαλάρωση.",
    "you-ce-xiong-suo-ru-tu-ji-span-stylecolorred-jin-zhang-span-zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Υπερτονία: δεξιός SCM. Αδυναμία: αριστερός SCM και οπίσθιος σκαληνός. Συνιστάται συμμετρική σταθεροποίηση/χαλάρωση.",
    "zuo-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Υπερτονία: αριστερός άνω τραπεζοειδής. Αδυναμία: μέσος/κάτω τραπεζοειδής. Συνιστάται προπόνηση (μέσου/κάτω) και χαλάρωση.",
    "kuan-nei-xuan-ji-qun-he-nei-shou-ji-qun-span-stylecolorred-jin-zhang-span-tun-zhong-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-zhong-ji-la-shen-nei-shou-ji-qun": "Υπερτονία: έσω στροφείς και προσαγωγοί ισχίου. Αδυναμία: μέσος γλουτιαίος. Συνιστάται προπόνηση μέσου γλουτιαίου και διάταση.",
    "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-nei-shou-ji-qun-la-shen-tun-zhong-ji-he-li-zhuang-ji": "Υπερτονία: μέσος γλουτιαίος και απιοειδής. Αδυναμία: προσαγωγοί, έσω στροφείς, LCL. Συνιστάται σταθεροποίηση ποδιών και χαλάρωση γλουτών.",
    "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-dan-ce-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "Υπερτονία: μέσος γλουτιαίος και απιοειδής. Ετερόπλευρη αδυναμία: προσαγωγοί, έσω στροφείς, LCL. Συνιστάται αμφοτερόπλευρη προπόνηση.",
    "jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "Σύσταση: Διατηρήστε ισορροπημένη προπόνηση και αποφύγετε τη μονομερή υπερβολική καταπόνηση.",
    "zuo-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Υπερτονία: αριστεροί οπίσθιοι μηριαίοι και ιγνυακός. Αδυναμία: τετρακέφαλος και υποκνημίδιος. Συνιστάται προπόνηση τετρακέφαλου/υποκνημίδιου και διάταση.",
    "zuo-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Υπερτονία: αριστερός τετρακέφαλος. Αδυναμία: μέγιστος γλουτιαίος και οπίσθιοι μηριαίοι. Συνιστάται προπόνηση γλουτών/οπίσθιας αλυσίδας και διάταση.",
    "you-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Υπερτονία: δεξιοί οπίσθιοι μηριαίοι και ιγνυακός. Αδυναμία: τετρακέφαλος και υποκνημίδιος. Συνιστάται προπόνηση τετρακέφαλου/υποκνημίδιου και διάταση.",
    "you-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Υπερτονία: δεξιός τετρακέφαλος. Αδυναμία: μέγιστος γλουτιαίος και οπίσθιοι μηριαίοι. Συνιστάται προπόνηση γλουτών/οπίσθιας αλυσίδας και διάταση.",
    "ji-zhu-jie-gou-qing-du-yi-chang-jian-yi-jia-qiang-zi-shi-guan-li-he-he-xin-ji-qun-xun-lian": "Ελαφριά απόκλιση σπονδυλικής στήλης. Προσοχή στη στάση και προπόνηση κορμού.",
    "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-zhuan-ye-jiao-zheng-gan-yu-bing-ding-qi-fu-cha-ping-gu": "Μέτρια απόκλιση σπονδυλικής στήλης. Συνιστάται καθοδηγούμενη προπόνηση.",
    "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-jiu-yi-jin-hang-duo-xue-ke-hui-zhen-ping-gu":"Σοβαρή δομική ανωμαλία της σπονδυλικής στήλης. Συνιστάται διεπιστημονική ιατρική γνωμάτευση και αξιολόγηση.",
    "ji-rou-ping-gu-zheng-chang-qing-ji-xu-bao-chi-liang-hao-de-sheng-huo-xi-guan": "Η αξιολόγηση των μυών της πυέλου είναι φυσιολογική. Παρακαλούμε συνεχίστε να διατηρείτε έναν υγιεινό τρόπο ζωής.",
    "teng-tong-qian-zai-feng-xian-ping-gu": "Αξιολόγηση Πιθανού Κινδύνου Πόνου",
    "jing-bu": "Αυχένας",
    "bei-bu": "Πλάτη",
    "yao-bu": "Μέση",
    "jing-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "Βαθμολογία Πιθανού Κινδύνου για Πόνο στον Αυχένα",
    "bei-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "Βαθμολογία Πιθανού Κινδύνου για Πόνο στην Πλάτη",
    "yao-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "Βαθμολογία Πιθανού Κινδύνου για Οσφυαλγία",
    "di-feng-xian": "Χαμηλός Κίνδυνος",
    "zhong-feng-xian": "Μεσαίος Κίνδυνος",
    "ji-zhu-jie-gou-ke-shi-hua": "Απεικόνιση Δομής Σπονδυλικής Στήλης",
    "tuo-dong-xuan-zhuan-shi-tu": "Σύρετε για περιστροφή",
    "ci-mo-xing-jin-gong-can-kao-shi-ji-ping-gu-yi-zhuan-ye-jian-ce-wei-zhun": "Αυτό το μοντέλο προορίζεται αποκλειστικά για αναφορά. Παρακαλούμε ανατρέξτε σε επαγγελματική αξιολόγηση για την τελική διάγνωση.",
    "bei-mian": "Πίσω",
    "zheng-shi-tu": "Μπροστινή όψη",
    "you-shi-tu": "Δεξιά όψη",
    "hou-shi-tu": "Οπίσθια όψη",
    "zuo-shi-tu": "Αριστερή όψη",
    "you-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Υπερτονία: δεξιός άνω τραπεζοειδής. Αδυναμία: μέσος/κάτω τραπεζοειδής. Συνιστάται προπόνηση (μέσου/κάτω) και χαλάρωση.",
    "tun-xing": "Σχήμα Γλουτών",
    "dui-bi": "Σύγκριση",
    "fang-xing-tun": "Τετράγωνο Σχήμα",
    "li-xing-tun": "Σχήμα Αχλαδιού",
    "dao-san-jiao-xing-tun": "Ανεστραμμένο Σχήμα V",
    "yuan-xing-tun": "Στρογγυλό Σχήμα",
    "jiao-li-xiang": "Ικανοποιητικό Σχήμα",
    "mi-tao-tun": "Σχήμα Καρδιάς",
    "ben-ci": "Τρέχουσα",
    "li-shi": "Ιστορικό",
    "ben-ci-li-shi": "Τρέχουσα, Ιστορικό",
    "tun-wei": "Περ. Γοφών",
    "tun-xing-shuo-ming": "Σχετικά με τα Σχήματα Γλουτών",
    "tun-xing-shi-zhi-ren-ti-hou-bei-bu-yu-da-tui-zhi-jian-de-bu-wei-suo-xing-cheng-de-qu-xian-he-xing-zhuang-tun-xing-ping-gu-ke-yi-bang-zhu-ren-men-geng-hao-di-shi-xian-xing-xiang-guan-li-he-jian-kang-guan-mai": "Το σχήμα των γλουτών αναφέρεται στην καμπύλη και τη μορφή της περιοχής μεταξύ της οσφυϊκής μοίρας και των μηρών. Αυτή η αξιολόγηση μπορεί να βοηθήσει τα άτομα να διαχειριστούν καλύτερα τη φυσική τους αισθητική και την υγεία τους.",
    "wo-zhi-dao-le": "Κατανοητό",
    "fang-xing-tun-fang-xing-tun-shi-jue-gan-guan-shang-xia-yi-yang-kuan-tun-liang-ce-xian-tiao-jiao-zhi-mei-you-hu-du": "Τετράγωνο Σχήμα: Το τετράγωνο σχήμα γλουτών χαρακτηρίζεται από παρόμοιο πλάτος στο πάνω και στο κάτω μέρος, με πιο ευθείες πλευρές και λιγότερες καμπύλες.",
    "yuan-xing-tun-shi-jue-gan-guan-xiang-yi-ge-yuan-xing-tun-bu-zhi-fang-fen-bu-jun-yun-yuan-run-bao-man-shi-fei-chang-li-xiang-de-tun-xing": "Στρογγυλό Σχήμα: Αυτό το σχήμα χαρακτηρίζεται από ομοιόμορφη κατανομή λίπους, δημιουργώντας μια γεμάτη και ισορροπημένη εμφάνιση. Θεωρείται ιδανικό σχήμα γλουτών.",
    "li-xing-tun-shi-jue-gan-guan-shang-zhai-xia-kuan-xia-tun-ji-rou-zhi-fang-fen-bu-jiao-duo-xian-tiao-bu-gou-feng-man": "Σχήμα Αχλαδιού: Αυτό το σχήμα χαρακτηρίζεται από το ότι είναι πιο στενό στο πάνω μέρος και πιο φαρδύ στο κάτω, με περισσότερη συσσώρευση λίπους και μυών στο κάτω τμήμα.",
    "dao-san-jiao-xing-tun-shi-jue-gan-guan-shang-kuan-xia-zhai-cheng-dao-san-jiao-xing": "Ανεστραμμένο Σχήμα V: Αυτό το σχήμα χαρακτηρίζεται από το ότι είναι πιο φαρδύ στο πάνω μέρος και στενότερο προς τα κάτω, μοιάζοντας με ανεστραμμένο τρίγωνο.",
    "mi-tao-tun-shi-jue-shang-xiang-yi-ge-mi-tao-xing-zhuang-tun-bu-xia-fang-feng-man-yao-bu-xian-xi-shi-fei-chang-li-xiang-de-tun-xing": "Σχήμα Ροδάκινου: Αυτό το σχήμα οπτικά μοιάζει με καρδιά, με πληρότητα στο κάτω μέρος των γλουτών που στενεύει προς μια πιο λεπτή μέση. Θεωρείται ιδανικό σχήμα.",
    "zan-wu-mo-xing": "Δεν υπάρχει διαθέσιμο μοντέλο.",
    "ce-liang": "Μέτρηση",
    "ben-ci-ce-liang": "Τρέχουσα Μέτρηση",
    "ben-ci-ce-liang-wei-he-cheng-cheng-gong-ke-dao-she-bei-zai-ci-ce-liang": "Η δημιουργία του μοντέλου για την τρέχουσα μέτρηση απέτυχε. Παρακαλούμε δοκιμάστε να σαρώσετε ξανά στη συσκευή.",
    "gai-ri-qi-wu-mo-xing-qing-xuan-ze-qi-ta-dui-bi-ri-qi": "Δεν υπάρχει διαθέσιμο μοντέλο για αυτήν την ημερομηνία. Παρακαλούμε επιλέξτε άλλη ημερομηνία για σύγκριση.",
    "shou-ci-ce-liang-zan-wu-li-shi-shu-ju": "Πρώτη μέτρηση, δεν υπάρχουν διαθέσιμα ιστορικά δεδομένα.",
    "mo-xing-jia-zai-shi-bai-qing-shua-xin-ye-mian-chang-shi-yi-xia": "Η φόρτωση του μοντέλου απέτυχε. Παρακαλούμε ανανεώστε τη σελίδα και δοκιμάστε ξανά.",
    "jing-zhui-7": "C7 (7ος Αυχενικός Σπόνδυλος)",
    "di-gu-zhong-dian": "Μέσο Ιερού Οστού",
    "di-gu-hou-shang-jiao": "Οπίσθια Άνω Γωνία του Ιερού Οστού",
    "ren-ti-zhong-xin": "Κέντρο Βάρους",
    "spine-tips1":"Αυτή η αναφορά προορίζεται αποκλειστικά για αναφορά και δεν πρέπει να χρησιμοποιείται ως βάση για ιατρική διάγνωση. Συνιστάται μια ολοκληρωμένη αξιολόγηση κατόπιν συνεννόησης με γιατρό.",
    "spine-tips2": "2025 Visbody Σύστημα Αξιολόγησης της Υγείας της Σπονδυλικής Στήλης",
    'tun-xing-ping-gu': 'Αξιολόγηση Σχήματος Γλουτών',
    "yi-xia-shi-nin-de-tun-xing-lei-xing":"Αυτός είναι ο τύπος σχήματος των γλουτών σας",
    "qi-ta-tun-xing": "Άλλα Σχήματα Γλουτών",
    "ji-zhu-ping-gu": "Αξιολόγηση Σπονδυλικής Στήλης",
    "qing-shao-nian-ji-zhu-zhuan-xiang-feng-xian-ping-gu":"Αξιολόγηση Κινδύνου Σπονδυλικής Εφήβων",
    "qing-shao-nian-ji-zhu-fa-yu-zhi-shu": "Δείκτης εφηβικής σπονδυλικής ανάπτυξης",
    "xue-xi-zi-shi-fu-he-zhi-shu": "Δείκτης Φόρτισης Στάσης Σπουδών",
    "gu-ge-ping-heng-zhi-shu":"Δείκτης Σκελετικής Ισορροπίας",
    "sheng-chang-qi-teng-tong-yu-jing-zhi-shu": "Δείκτης προειδοποίησης πόνων ανάπτυξης",
    "ji-zhu-ce-wan-feng-xian-ping-fen": "Βαθμολογία Κινδύνου Σκολίωσης",
    "qia-yao-ji-shu-ji-ji":"Λαγονοψοΐτης/Ανελκτήρες της σπονδυλικής στήλης",
    "xia-bu-jin-zhang-fu-heng-ji-bao-ruo":"Τάση στην κατώτερη περιοχή, αδυναμία εγκάρσιου κοιλιακού μυός",
    "ji-zhu-fa-yu-zheng-chang-wu-ming-xian-jie-gou-wen-ti":"Φυσιολογική ανάπτυξη της σπονδυλικής στήλης, χωρίς σημαντικά δομικά προβλήματα.",
    "cun-zai-qing-wei-fa-yu-yin-huan-jian-yi-gai-shan-zi-shi-xi-guan":"Υπάρχουν ήπιοι αναπτυξιακοί κίνδυνοι. Συνιστάται η βελτίωση των συνηθειών στάσης του σώματος.",
    "zhong-du-fa-yu-feng-xian":"Μέτριος αναπτυξιακός κίνδυνος.",
    "yan-zhong-ying-xiang-ji-zhu-fa-yu":"Επηρεάζει σοβαρά την ανάπτυξη της σπονδυλικής στήλης.",
    "xue-xi-zi-shi-liang-hao-ke-chang-shi-jian-wei-chi":"Καλή στάση μελέτης, διατηρήσιμη για μεγάλα χρονικά διαστήματα.",
    "zi-shi-you-dai-gai-shan-jian-yi-mei-45-fen-zhong-xiu-xi":"Η στάση του σώματος χρειάζεται βελτίωση. Συνιστάται ένα διάλειμμα κάθε 45 λεπτά.",
    "cun-zai-ming-xian-zi-shi-wen-ti-xu-yao-ding-qi-la-shen":"Υπάρχουν σημαντικά προβλήματα στάσης. Απαιτούνται τακτικές διατάσεις.",
    "xue-xi-zi-shi-yan-zhong-bu-liang-huo-jiang-ying-xiang-xue-xi-xiao-shuai-he-fa-yu":"Πολύ κακή στάση μελέτης, η οποία μπορεί να επηρεάσει την αποδοτικότητα της μάθησης και την ανάπτυξη.",
    "gu-ge-fa-yu-dui-cheng-zi-shi-wen-ding":"Συμμετρική σκελετική ανάπτυξη, σταθερή στάση σώματος.",
    "cun-zai-qing-wei-bu-dui-cheng-jian-yi-jian-ce":"Εντοπίστηκε μικρή ασυμμετρία. Συνιστάται παρακολούθηση.",
    "fa-yu-bu-jun-yun-xu-yao-jiu-zheng-cuo-shi":"Άνιση ανάπτυξη, απαιτούνται διορθωτικά μέτρα.",
    "gu-ge-fa-yu-yan-zhong-bu-dui-cheng-ying-xiang-sheng-chang":"Σοβαρή σκελετική ασυμμετρία που επηρεάζει την ανάπτυξη.",
    "zi-shi-liang-hao-teng-tong-feng-xian-di":"Καλή στάση σώματος, χαμηλός κίνδυνος πόνου.",
    "qing-du-teng-tong-feng-xian-jian-yi-zi-shi-guan-li":"Ήπιος κίνδυνος πόνου. Συνιστάται διαχείριση της στάσης του σώματος.",
    "zhong-du-teng-tong-feng-xian-xu-zhuan-ye-zhi-dao":"Μέτριος κίνδυνος πόνου, απαιτείται επαγγελματική καθοδήγηση.",
    "gao-du-teng-tong-feng-xian-ke-neng-yi-you-bu-shi-gan":"Υψηλός κίνδυνος πόνου, μπορεί ήδη να υπάρχει δυσφορία.",
    "di-feng-xian-qing-bao-chi-liang-hao-zi-shi-xi-guan":"Χαμηλός κίνδυνος. Παρακαλούμε διατηρήστε καλές συνήθειες στάσης του σώματος.",
    "zhong-feng-xian-ke-neng-xu-yao-jin-yi-bu-guan-cha-huo-gan-yu":"Μεσαίος κίνδυνος. Μπορεί να χρειαστεί περαιτέρω παρακολούθηση ή παρέμβαση.",
    "gao-feng-xian-xu-yao-ji-shi-jiu-yi-jin-hang-zhuan-ye-yi-liao-ping-gu-gan-yu":"Υψηλός κίνδυνος. Παρακαλούμε αναζητήστε έγκαιρη ιατρική αξιολόγηση και παρέμβαση.",
    "you-liang":"Άριστα",
    "zhu-yi":"Προσοχή",
    "gan-yu":"Δράση",
    "jing-shi":"Ειδοπ.",
    "di-fu-he":"Φορτίο: Χαμ.",
    "zhong-fu-he":"Φορτίο: Μεσ.",
    "gao-fu-he":"Φορτίο: Υψ.",
    "guo-zai":"Υπερφόρτωση",
    "ping-heng-xing":"Ισορροπημένο",
    "qing-du-bu-ping-heng":"Ήπια ανισορροπία",
    "zhong-du-bu-ping-heng":"Μέτρια ανισορροπία",
    "yan-zhong-bu-ping-heng":"Σοβαρή ανισορροπία",
    "an-quan":"Ασφαλές",
    "wei-xian":"Κίνδυνος",
    "wu-yi-chang": "Νόρμαλ",
    balanceReport: {
            scoreUnit: 'Βαθμολογία',
            compareLast: 'Καθαρό',
            status: {
                excellent: 'Eξαιρετικό',
                good: 'Kαλό',
                medium: 'Μέτριο',
                fair: 'Φυσιολογικό',
                poor: 'Αδύναμο'
            },
            levelDesc: [
                'Eξαιρετικό',
                'Kαλό',
                'Φυσιολογικό',
                'Αδύναμο'
            ],
            systemEvaluation: 'Αξιολ. Αισθητ. Συστήματος',
            visualEvaluation: 'Αξιολ. Οπτικού Αισθητ. Συστ.',
            evaluationLevel: 'Κατάταξη',
            unit: 'Μονάδα:',
            swayRms: 'Δείκτης Ταλάντωσης',
            eyeCloseTest: 'Στατική Ισορροπία (Κλειστά Μάτια)',
            copArea: 'Περιοχή Τροχιάς Κέντρου Πίεσης (COP)',
            avgSpeed: 'Μέση Ταχύτητα',
            maxDisplacement: 'Μέγιστη Μετατόπιση',
            centerTrajectory: 'Διαδρομή Μετατόπισης Κέντρου Πίεσης (COP)',
            eyeOpenTest: 'Στατική Ισορροπία (Ανοιχτά Μάτια)',
            last: 'Τελευταίος ',
            conclusion: {
                eyeClose: {
                    level1: 'Ισορροπία (Κλειστά Μάτια): Εξαιρετική (Α). Αποτελεσματική αισθητηριακή ολοκλήρωση επιτρέπει σταθερότητα χωρίς όραση, ελεύθερη κίνηση στο σκοτάδι.',
                    level2: 'Ισορροπία (Κλειστά Μάτια): Καλή (Β). Αποτελεσματική σωματοαισθητική αντιστάθμιση επιτρέπει προσαρμογές χωρίς όραση. Καθημερινές ενέργειες φυσιολογικές· σύντομη προσαρμογή απαιτείται σε ξαφνικό κλείσιμο ματιών.',
                    level3: 'Ισορροπία (Κλειστά Μάτια): Φυσιολογική (C). Υποβέλτιστη αισθητηριακή λειτουργία οδηγεί σε μεγαλύτερη ταλάντωση. Πιθανή αστάθεια χωρίς οπτική βοήθεια· ενδέχεται να χρειαστεί υποστήριξη.',
                    level4: 'Ισορροπία (Κλειστά Μάτια): Αδύναμη (D). Πιθανές διαταραχές συστήματος δυσκολεύουν την ισορροπία χωρίς οπτική βοήθεια. Σημαντικά αυξημένος κίνδυνος πτώσης στο σκοτάδι.'
                },
                eyeOpen: {
                    level1: 'Ισορροπία (Ανοιχτά Μάτια): Εξαιρετική (Α). Εξαιρετικά αποτελεσματική οπτική-σωματοαισθητική ολοκλήρωση εξασφαλίζει σταθερή στάση με χαμηλή ενέργεια. Προσαρμόζεται καλά σε πολύπλοκα περιβάλλοντα.',
                    level2: 'Ισορροπία (Ανοιχτά Μάτια): Καλή (Β). Βασίζεται κυρίως στην οπτική ανάδραση για έλεγχο, συμπληρωμένη από σωματοαισθητική είσοδο. Σταθερότητα κατά τις καθημερινές δραστηριότητες.',
                    level3: 'Ισορροπία με Ανοιχτά Μάτια: Κανονική (Επίπεδο C). Σχετικά ασταθής στάση, μειωμένη ικανότητα χρήσης οπτικών ερεθισμάτων για διόρθωση ισορροπίας. Επιρρεπής σε αστάθεια σε περιβάλλοντα με οπτικές παρεμβολές.',
                    level4: 'Ισορροπία (Ανοιχτά Μάτια): Αδύναμη (D). Αισθητή ταλάντωση· φτωχή ικανότητα χρήσης οπτικής εισόδου για ισορροπία. Πιθανά προβλήματα αισθητηριακής ολοκλήρωσης. Φτωχή σταθερότητα σε καθημερινές δραστηριότητες αυξάνει τον κίνδυνο πτώσεων.'
                }
            },
            levelStatus: {
                A: 'Βαθμός Α',
                B: 'Βαθμός Β',
                C: 'Βαθμός C',
                D: 'Βαθμός D'
            },
            chart: {
                eyeCloseTest: 'Στάση (Κλειστά Μάτια)',
                eyeOpenTest: 'Στάση (Ανοιχτά Μάτια)',
                yAxisLabels: ['Χαμηλό', 'Μέτριο', 'Υψηλό']
            },
            selectionRport: "Επιλέξτε αναφορά για σύγκριση",
            measureDes: "Αναλυτικά Αποτελέσματα Ανά Παράμετρο",
            balanceTittle: "Αξιολόγηση Ισορροπίας",
            pingDes: "Κατάταξη: Εξαιρετικό, Καλό, Κανονικό, Αδύναμο"
        },
  "neckReport": {
  "title": "Λειτουργίες αυχένα",
  "conclusion": "Συμπέρασμα αξιολόγησης λειτουργίας αυχένα",
  "loading": "Η αναφορά δημιουργείται. Παρακαλώ περιμένετε.",
  "failed": "Αποτυχία σύνθεσης",
  "analysis": "Ανάλυση",
  "suggestion": "Πρόταση",
  "suggestionText": "Αναζητήστε ειδικό για διάγνωση και θεραπεία"
}
}
